import React from 'react';
import Seo from '../components/Seo';
import ContentPostList from '../components/content/ContentPostList';
import { articlesService } from '../api';
import './InfoPages.css';

const ArticlesPage = () => (
    <div className="info-page">
        <Seo title="Статьи" description="Статьи о недвижимости, ремонте и аренде." />
        <h1 className="info-page__title">Статьи</h1>
        <ContentPostList service={articlesService} basePath="/articles" />
    </div>
);

export default ArticlesPage;
